import TrialBalanceComponent from "components/Reports/TrialBalanceComponent";

export default function TrialBalance() {
    return <TrialBalanceComponent/>;
}
